/* eslint-disable react/jsx-props-no-spreading */
import {
    Drawer as MantineDrawer,
    DrawerProps as MantineDrawerProps
} from '@mantine/core';
// components
import DrawerMenu from '@/components/Drawer/components/DrawerMenu';
// utils
import useDrawerStore from '@/components/Drawer/Drawer.store.ts';
import {
    TDrawerSize,
    TDrawerPosition
} from '@/components/Drawer/Drawer.types.ts';
import { DRAWER_SIZE } from '@/components/Drawer/Drawers.utils.ts';

interface DrawerProps extends MantineDrawerProps {
    name: string;
    size: TDrawerSize;
    position: TDrawerPosition;
}

const Drawer = ({
    children,
    name,
    size,
    position,
    title,
    withOverlay,
    ...rest
}: DrawerProps) => {
    const ui = useDrawerStore((state) => state.ui[name]);

    const finalPosition = ui?.position ?? position;
    const sizeKey = ui?.size ?? size;

    return (
        <MantineDrawer.Root
            position={finalPosition}
            size={DRAWER_SIZE[sizeKey]}
            {...rest}
        >
            {withOverlay ? <MantineDrawer.Overlay /> : undefined}
            <MantineDrawer.Content>
                <MantineDrawer.Header className="flex items-center gap-4">
                    <MantineDrawer.Title className="break-all">
                        {title}
                    </MantineDrawer.Title>
                    <DrawerMenu
                        className="ml-auto"
                        name={name}
                        position={finalPosition}
                        size={sizeKey}
                    />
                    <MantineDrawer.CloseButton className="ml-0" />
                </MantineDrawer.Header>
                <MantineDrawer.Body>{children}</MantineDrawer.Body>
            </MantineDrawer.Content>
        </MantineDrawer.Root>
    );
};

export default Drawer;
